import { CommonModule } from '@angular/common';
import { ChangeDetectorRef, Component, CUSTOM_ELEMENTS_SCHEMA, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { NzGridModule } from 'ng-zorro-antd/grid';
import { NZ_MODAL_DATA, NzModalRef } from 'ng-zorro-antd/modal';
import { HttpService } from '../../../../services/http.service';
import { UserAccountDTO } from '../../../../classes/user-account.dto';
import { StorageService } from '../../../../services/storage.service';

@Component({
  selector: 'app-modal-doctor-details',
  standalone: true,
  imports: [TranslateModule, NzDividerModule, CommonModule, NzGridModule, ReactiveFormsModule ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-doctor-details.component.html',
  styleUrl: './modal-doctor-details.component.scss'
})
export class ModalDoctorDetailsComponent implements OnInit{

  doctorDetails: any;
  isEditing: boolean = false;
  editForm!: FormGroup;

  constructor(
    private modalRef: NzModalRef,
    @Inject(NZ_MODAL_DATA) private data: any,
    private fb: FormBuilder,
    private http: HttpService,
    private storage: StorageService,
    private cdr: ChangeDetectorRef

  ) {
    this.doctorDetails = this.data.doctorDetails;
  }

  ngOnInit(){
    this.editForm = this.fb.group({
      name: [this.doctorDetails.name, Validators.required],
      surname: [this.doctorDetails.surname, Validators.required],
      address: [this.doctorDetails.address, Validators.required],
      phone: [this.doctorDetails.phone, Validators.required],
      mail: [this.doctorDetails.mail, [Validators.required, Validators.email]]
    });
  }


  startEditing(){
    this.isEditing = true;
  }

  saveDoctorDetail(){
    const userData = JSON.parse(this.storage.getItem('userData')!) as UserAccountDTO;
    const individualId = userData.individualId;
    const updatedDoctor = this.editForm?.value;
    this.http.saveDoctorDetails(individualId, updatedDoctor).subscribe({
      next: () => {
        this.doctorDetails = { ...updatedDoctor };
        this.isEditing = false;
      },
      error: (error) => {
        console.error('Errore durante il salvataggio dei dettagli:', error);
      }
    });
  }

  closeEditing(){
    this.isEditing = false;
  }

  close(): void {
    const updatedDoctor = this.editForm?.value;
    this.modalRef.close(updatedDoctor);  }

}
